import React from 'react';

export default function Emily() {
    return (
        <article>
            <p>Dr. Emily is a Chiropractor, Acupuncture Provider and Performance Therapist with a passion for fitness and medicine. She has been ranked as the top female Chiropractor on Toronto’s rateMDs.com website from 2019-2020 and has helped hundreds of athletes and active individuals overcome pain & injury to perform at their best.</p>

            <p>Dr. Emily obtained her Doctor of Chiropractic in Toronto; which she received multiple academic awards including Magna Cum Laude, clinical honors and Dean's list recognition. She has also completed many additional certifications specializing in movement assessment, rehab and therapeutics.</p>

            <p>She has a special interest in traveling to underprivileged countries and giving back; having had the opportunity to travel/treat in Peru, the Dominican Republic and Honduras on Chiropractic Without Borders medical trips. Dr. Emily further trained in Toronto for 6 months; studying nerve entrapment disorders in the human body; their diagnosis, treatment and interplay with chronic and acute injuries.</p>
        </article>
    )
};
